import React from "react";
import { useNavigate } from "react-router-dom";

import { useBotMeetingScheduledInterviewQuery } from "../../../graphql";
import { getQueryString } from "../utils";

type StartAsInPersonParams = {
  meetingUrl: string;
  botMeetingId: string | null;
  zoomMeetingId: string | null;
};

/**
 * Fetches scheduled interview data for the given video meeting and
 * redirect to the in-person interview page.
 */
export const StartAsInPerson: React.FC<StartAsInPersonParams> = ({
  zoomMeetingId,
  botMeetingId,
  meetingUrl,
}) => {
  const navigate = useNavigate();

  useBotMeetingScheduledInterviewQuery({
    variables: {
      zoomMeetingId: parseInt(zoomMeetingId ?? "", 10) || undefined,
      botMeetingId,
      meetingUrl,
    },
    onCompleted: (data) => {
      const scheduledInterview = data.botMeetingScheduledInterview;
      navigate(
        `/${getQueryString({
          isInPersonInterview: true,
          scheduledInterviewId: scheduledInterview?.id,
          interviewers: JSON.stringify(
            scheduledInterview?.scheduledInterviewers
              .filter(({ user }) => !!user)
              .map(({ user }) => ({
                id: user?.id,
                fullName: user?.fullName,
                email: user?.email,
              }))
          ),
          candidateId: scheduledInterview?.candidate?.id,
          positionId: scheduledInterview?.position?.id,
          callGuideId: scheduledInterview?.callGuide?.id,
          name: scheduledInterview?.name,
        })}`,
        { replace: true }
      );
    },
    onError: () => {
      navigate(`/${getQueryString({ isInPersonInterview: true })}`, {
        replace: true,
      });
    },
  });

  return null;
};
